export default [
  {
    key: 'checkbox',
    label: '',
    thClass: 'align-middle text-center',
    class: 'align-middle text-center',
    sortable: false,
    show: true,
    type: 'checkbox',
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    class: 'text-center',
    show: true,
  },
  {
    key: 'company_id',
    label: 'Company',
    sortable: true,
    class: 'text-center',
    show: true,
  },
  {
    key: 'station_id',
    label: 'Station',
    sortable: true,
    class: 'text-center',
    show: true,
  },
  {
    key: 'created_at',
    label: 'Created At',
    sortable: true,
    class: 'text-center',
    show: false,
  },
  {
    key: 'updated_at',
    label: 'Update At',
    sortable: true,
    class: 'text-center',
    show: true,
  },
  {
    key: 'action',
    label: 'Action',
    class: 'text-center',
    sortable: false,
    show: true,
  },
]
